import { useMemo } from 'react';

import { useSearchParameter } from '@xing-com/crate-hooks-use-search-parameter';
import {
  AI_FORCE_CS_ANIMATION_KEY,
  SEARCH_QUERY_ID_PARAM,
  SEARCH_STATE_PARAMS,
} from '@xing-com/crate-jobs-constants';
import { useIsAiSearch } from '@xing-com/crate-jobs-hooks';

export const useHideAside = (): boolean => {
  const { getSearchParameter } = useSearchParameter();
  const isAiSearch = useIsAiSearch();

  const id = getSearchParameter(SEARCH_QUERY_ID_PARAM);
  const keywords = getSearchParameter(SEARCH_STATE_PARAMS.keywords);
  const hasAnimation = Boolean(getSearchParameter(AI_FORCE_CS_ANIMATION_KEY));

  return useMemo(
    () => Boolean(isAiSearch && (!id || (id && !keywords)) && !hasAnimation),
    [id, isAiSearch, keywords, hasAnimation]
  );
};
